export async function fetchUserByEmail(email) {
    const response = await fetch(`/api/admin/lookup-user/${email}`);
    if (response.ok) {
        return response.json();
    }
    return null;
}